import axiosInstance from "../../../../api/axiosConfig";

export const addStockCategory = (data: any) => {
  return axiosInstance.post("/admin/stock-categories", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getStockCategory = (id: string) => {
  return axiosInstance.get(`/admin/stock-categories/${id}`);
};

export const updateStockCategory = (id: string, data: any) => {
  return axiosInstance.patch(`/admin/stock-categories/${id}`, data);
};
